<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form
      :inline="true"
      :model="formInline"
      label-position="right"
      label-width="120px"
      class="searchBar"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="企业状态：">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
            >
              <el-option
                v-for="type in enterpriseType"
                :label="type.key"
                :value="type.value"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业分类：">
            <el-select
              size="small"
              v-model="formInline.customerType"
              placeholder="请选择"
            >
              <el-option
                v-for="type in enterpriseCategoryType"
                :label="type.key"
                :value="type.value"
                :key="type.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              v-hasPerm="btn_perm_type.client.add"
              @click="handleEdit()"
              icon="el-icon-plus"
              >新增</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" label="操作" width="240">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.client.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.client.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="customerName"
        label="名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="customerType"
        label="分类"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="createDate"
        label="创建时间"
        width="100px"
        show-overflow-tooltip
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        sortable
        prop="status"
        label="状态"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <!-- 编辑界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :edit-form="editForm"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
import { listClient, delClient } from "@/api/ticket/client";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import { timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      loading: false,
      editFormVisible: false,
      title: "",
      enterpriseType: [
        { key: "全部", value: "" },
        { key: "正常", value: "正常" },
        { key: "异常", value: "异常" },
      ],
      enterpriseCategoryType: [
        { key: "全部", value: "" },
        { key: "企业", value: "企业" },
        { key: "银行", value: "银行" },
      ],
      editForm: {},
      formInline: {
        status: "",
        customerType: "",
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
    };
  },
  components: {
    Pagination,
    EditForm,
  },
  created() {
    this.getData(this.formInline);
  },
  methods: {
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    getData() {
      this.loading = true;
      listClient(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(({ content, page, size, totalCount }) => {
          this.userData = content;
          this.pager.currentPage = page;
          this.pager.pageSize = size;
          this.pager.total = totalCount;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        status: "",
        customerType: "",
      };
      this.getData();
    },
    handleEdit(row, readonly) {
      if (row) {
        this.title = "修改客户";
        this.editForm = row;
      } else {
        this.title = "添加客户";
        this.editForm = {};
      }
      if (readonly) {
        this.editFormDetailVisible = true;
      } else {
        this.editFormVisible = true;
      }
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delClient(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
.el-input {
  width: auto !important;
}
</style> 


// WEBPACK FOOTER //
// src/views/ticket/ticket-client/index.vue